import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";


const MessageContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    min-height: 150px;
    font-size: ${props => props.theme.fontSize.body1};
    padding: ${props => props.theme.spacing.spacing20};
    color: ${props => props.theme.colors.notesTint};
`


const TextBox = styled.div`
    margin-bottom: ${props => props.theme.spacing.spacing16};
    white-space: nowrap;
`

interface EmptyDropDownMessageComponentProps {
    message: string | React.ReactElement;
    className?: string;
}

export const EmptyDropDownMessageComponent: React.FC<EmptyDropDownMessageComponentProps> = observer((props) => {

    return (
        <MessageContainerBox className={props.className}>
            <TextBox>
                {props.message}
            </TextBox>
        </MessageContainerBox>
    )
});
